import { css } from '@emotion/core';
import { a2bTheme } from '@olxeu-a2b/ui/src/theme/styled';
import { SheetBottom } from '@nexus/lib-react/dist/core/SheetBottom/SheetBottom';
import { Modal } from '@nexus/lib-react/dist/core/Modal/Modal';
import { Headline3, Headline5, Paragraph6 } from '@nexus/lib-react/dist/core/Typography';
import styled from '../../../theme/styled';
import { mq } from '../../styles';

type StyledTheme = Partial<a2bTheme>;

const flexBoxCol = () => css`
  display: flex;
  flex-direction: column;
`;

const SheetBottomModal = styled(SheetBottom)`
  ${mq.mobileAndPhabletHorizontal} {
    overflow: auto;
    height: 100vh;
    top: 0;
  }
`;

const ModalWrapper = styled(Modal)`
  ${({ theme }: { theme: StyledTheme }) => `
    z-index:${theme.zIndices.fixed};
  `}

  max-width: 552px;
  > div:first-of-type {
    padding-bottom: 0;
  }
`;

const ModalContent = styled.div`
  ${flexBoxCol};
  padding: 0 ${({ theme }) => theme.space[8]};

  ${mq.desktop} {
    justify-content: center;
    padding: 0 ${({ theme }) => theme.space[26]} ${({ theme }) => theme.space[26]};
  }
`;

const ModalDesktopHeadline = styled(Headline3)`
  padding: ${({ theme }) => theme.space[10]} 0 ${({ theme }) => theme.space[24]};
  text-align: center;
`;

const ModalMobileHeadline = styled(Headline5)`
  padding: ${({ theme }) => theme.space[10]} 0 ${({ theme }) => theme.space[18]};
  text-align: center;
  ${mq.smallMobile} {
    font-size: ${({ theme }: { theme: StyledTheme }) => theme.fontSizes[16]};
  }
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const ListItem = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  gap: 16px;
`;

const ListItemImage = styled.div`
  min-height: 48px;
  min-width: 48px;
  background-color: ${({ theme }) => theme.colors.grey2};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ListItemParagraph = styled(Paragraph6)`
  font-style: normal;
  ${mq.desktop} {
    font-size: ${({ theme }) => theme.fontSizes[14]};
    line-height: ${({ theme }) => theme.fontSizes[16]};
  }
`;

const HelpCenterLink = styled(Paragraph6)`
  align-self: center;
  margin-top: ${({ theme }) => theme.sizes[24]};

  ${({ theme }) => css`
    ${mq.desktop} {
      font-size: ${theme.fontSizes[14]};
      line-height: ${theme.lineHeights[18]};
    }

    > a {
      color: ${theme.colors['text-global-secondary']};
    }
  `}
`;

export default {
  ListItem,
  ModalWrapper,
  SheetBottomModal,
  ModalDesktopHeadline,
  ModalMobileHeadline,
  ModalContent,
  ModalBody,
  HelpCenterLink,
  ListItemImage,
  ListItemParagraph,
};
